<template>
  <div class="home">
    <div class="head">
      <div class="download-box">
        <img src="./../assets/img/download.png" @click="downloadApk" class="download" alt="下载" />
      </div>
      <div class="first-step"> 
        <img class="step" src="./../assets/img/title1.png" alt="第一步"/>
        <div class="bianzu-box">
          <transition enter-class="fadeEnter" enter-active-class="fadeActive"> 
          <img class="bianzu1"  v-show="step1" src="./../assets/img/bianzu1.png" alt="">
          </transition>

        </div>
        <div class="nfc">
          扫二维码/靠近NFC贴纸下载应用
          <!-- 将手机靠近NFC贴纸或遥控标识处下载爱投屏 -->
        </div>
        <div class="nfc-text">
          （手机需要支持和开启NFC功能）
        </div>
      </div>
    </div>

    <div class="two-step">
      <div>
        <img class="title2"  src="./../assets/img/title2.png" alt="第二步"/>
      </div>
      <div  id="bianzu1-box">
        <transition enter-class="scaleEnter" enter-active-class="scaleActive"> 
          <img ref="bianzu1-img"  v-show="show" src="./../assets/img/bianzu2.png" alt="bianzu2" />
        </transition>
        
      </div>
      <div >
        手机设置开启NFC功能及权限
        <p class="phomeData">（部分手机需要开启NFC数据传输）</p>
      </div>
    </div>

    <div class="three-step">
      <div>
        <img class="title3"  src="./../assets/img/title3.png" alt="第三步"/>
      </div>
      <div id="bianzu3-img">
        <transition enter-class="slateEnter" enter-active-class="slateActive"> 
          <img class="bianzu3"  v-show="show3" src="./../assets/img/bianzu3.png" alt="bianzu2" />
        </transition>
      </div>
      <div class="text">
        <p>再次将手机靠近NFC贴纸</p>
        <p>（手机和电视需在同一网络内）</p>
      </div>

    </div>


      <div class="note">
        <div class="text">
          1、使用NFC贴纸前需要，确认NFC功能开启并且允许数据传输；<br/>
          2、该NFC标签使用时不要靠近金属物品，否则可能导致手机无法投屏；<br/>
          3、NFC标签不能折弯，需要保持平整，否则导致NFC标签损坏；<br/>
          4、当您的NFC标签贴物体表面时，请尽量保持标签表面整洁。
        </div>
        <p><a href="" >ICP备案号：京ICP备 14046433号-1</a></p>
      </div>
    </div>

    
</template>
<script>
// @ is an alias to /src
import { Toast  } from 'vant';
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      step1: false,
      show3: false,
      show: false,
    }
  },
  methods: {
    getRect (element) {
      var rect = element.getBoundingClientRect() // 距离视窗的距离
      var top = document.documentElement.clientTop ? document.documentElement.clientTop : 0 // html元素对象的上边框的宽度
      var left = document.documentElement.clientLeft ? document.documentElement.clientLeft : 0
      return {
        top: rect.top - top,
        bottom: rect.bottom - top,
        left: rect.left - left,
        right: rect.right - left
      }
    },
    downloadApk() {
      let ua = navigator.userAgent;
      // let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1;
      let isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let isWeixin = ua.indexOf("MicroMessenger") > 0; 
      if (isWeixin) {
        Toast('移步至手机浏览器中下载~');
      } else if (isIOS) {
        Toast('暂无IPhone版本~');
      } else {  //统一认作安卓系统处理
        Toast.loading({
          message: '开始下载',
          forbidClick: true,
        });
        location.href = 'https://skytv.cc/itprelease/apks/skycast_nfc_release.apk';
        // location.href = 'https://5d74d3ae18cf661020b79b194f8d7373.dlied1.cdntips.net/download.sj.qq.com/upload/connAssitantDownload/upload/MobileAssistant_1.apk?mkey=623959b13a3c26b7&f=07b4&cip=58.60.0.66&proto=https'
      }
    }
  },


  mounted() {
    

    this.$nextTick(()=> {
    this.step1  = true;
    var $box = document.getElementById('bianzu1-box')
    var $box1 = document.getElementById('bianzu3-img')
    
    var divH = $box.offsetHeight // div高度
    var windowH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight // 浏览器高度兼容写法
    window.onscroll = () => {
      var obj = this.getRect($box);
      var obj1 = this.getRect($box1);
      // if (obj.top < windowH && obj.bottom >= windowH) { // 正在出现
      //   console.log('84正在出现')
      //   // console.log(this.$refs['bianzu1-img'].style.css = '');
      // }
      if (obj.top > 0 && obj.top < windowH && obj.bottom > 0 && obj.bottom < windowH) { // 正在视口中
        this.show = true;
      }

      if (obj1.top > 0 && obj1.top < windowH && obj1.bottom > 0 && obj1.bottom < windowH) { // 正在视口中
        this.show3 = true;
      }
      // if (obj1.bottom <= 0) { // 已经离开视口
      //   this.show3 =  false;
      // }
     
      
    }
    })
  },
}
</script>


<style scoped lang="scss">
p{
  padding: 0;
  margin: 0;
}
.slateActive {
  transition: all 3s;
}
.slateEnter{
  transform: translateX(-100%);
}


.scaleActive {
  transition: all 3s;
}
.scaleEnter{
  transform: scale(0);
}

.fadeActive{ 
  transition: opacity 4s; //类名：隐藏到显示过程所需要的时间
}
.fadeEnter { // 类名:初始化状态
  opacity: 0;
}


.head{
  position: relative;
  width: 100vw;
  height: 1953px;
  background-image: url(./../assets/img/header.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  // background-color: aqua;
  .download-box{
    position: absolute;
    width: 100vw;
    top: 505px;
    display: flex;
    justify-content: center;
    img{
      width: 305px;
      height: 86px;
    }
    img:active{
      transform: scale(1.2);
      opacity: 0.7;
    }
  }
  .step{
    position: absolute;
    left: 215px;
    top: 900px;
    width: 220px;
    height: 114px;
  }
  .nfc{
    position: absolute;
    top: 1769px;
    left: 74px;
    width: 601px;
    text-align: center;
    font-size: 40px;
    font-family: XINH_ZC--GB1-0, XINH_ZC--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 56px;
  }
  .nfc-text{
    position: absolute;
    opacity: 0.6;
    top: 1828px;
    width: 100vw;
    height: 56px;
    font-size: 24px;
    text-align: center;
    font-family: XINH_ZC--GB1-0, XINH_ZC--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 56px;

  }
  
.bianzu-box{
  width: 100vw;
  display: flex;
  justify-content: center;
  .bianzu1{
    position: absolute;
    top: 1081px;
    width: 480px;
    height: 640px;
  }


}

  

}
.two-step, .three-step{
  margin-top: 240px;
  div:nth-child(1){
    padding-left: 215px;
    img{
      width: 220px;
      height: 114px;
    }
  }
  div:nth-child(2){
    display: flex;
    justify-content: center;
    margin-top: 59px;
    img{
      width: 398px;
      height: 692px;
      // transform: scale(0);
      // &.show{
      //   transform: scale(1);
      //   animation: all .7s;
      // }
    }
  }

  div:nth-child(3){
    text-align: center;
    height: 56px;
    margin-top: 32px;
    font-size: 40px;
    font-family: XINH_ZC--GB1-0, XINH_ZC--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 56px;
    .phomeData{
      opacity: 0.6;
      font-size: 24px;
      font-family: XINH_ZC--GB1-0, XINH_ZC--GB1;
      font-weight: normal;
    }
  }
  
}

.three-step{
  margin-bottom: 311px;
  div:nth-child(2){
    margin-top: 61px;
    .bianzu3{
      width: 646px;
      height: 324px;
    }
  }
  .text{
    width: 560px;
    margin-left: 96px;
    p{
      margin: 0;
      height: 56px;
      text-align: center;
    }
    p:nth-child(2){
      // margin-top: 16px;
      opacity: 0.6;
      font-size: 24px;
      font-family: XINH_ZC--GB1-0, XINH_ZC--GB1;
      font-weight: normal;

    }


  }
  .text-msg{
    background-color: #FFFFFF;
    opacity: 0.6;
    // height: 56px;
    text-align: center;
    font-size: 24px;
    font-family: XINH_ZC--GB1-0, XINH_ZC--GB1;
    font-weight: normal;
    color: #FFFFFF;
    // line-height: 56px;
  }

}
.note{
  
  width: 100vw;
  height: 505px;
  background-image: url(./../assets/img/bianzu4.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  // padding-top: 133px;
  .text {
    margin-left: 33px;
    padding-top: 133px;
    width: 684px;
    // height: 192px;
    font-size: 24px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #000000;
    line-height: 48px;
    
  }
  p{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    height: 80px;

    a{
        text-decoration: none;
        color: #c6c6c6;
        font-size: 24px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        line-height: 33px;
    }
    
  }


}
</style>
